// Global
import { jsx as _jsx } from "react/jsx-runtime";
// Local
import BreadcrumbQuery from 'components/authorable/shared/site-structure/Breadcrumb/Breadcrumb.graphql';
import BreadcrumbClient from 'components/authorable/shared/site-structure/Breadcrumb/BreadcrumbClient';
import graphqlClientFactory from 'lib/graphql-client-factory';
// Server-safe entry point.
//
// Why split this file into a server entry + a client child (`BreadcrumbClient`)?
//
// The Default export below uses React hooks (`useSitecore`, `useIsMobile`, and
// `BrandAndThemeProvider` which calls `useContext`). Those require a Client
// Component.
//
// However, this file ALSO exports `getComponentServerProps`, which the Sitecore
// Content SDK invokes during server-side rendering. If we add `'use client'`
// here, the whole module becomes a Client Reference and the SDK can no longer
// call `getComponentServerProps` server-side (Next.js throws:
// "Attempted to call getComponentServerProps() from the server but
// getComponentServerProps is on the client").
//
// Under webpack, the Sitecore-provided `component-props.loader` in
// `next.config.js` strips `getComponentServerProps` from client bundles, which
// allows a single file with `'use client'` to work. But this project runs on
// Next.js 16's default Turbopack dev server, which ignores webpack rules, so
// that loader never runs and the trick breaks.
//
// The safe pattern (and the one supported in both webpack and Turbopack):
//   - Keep this file plain (no `'use client'`). It exports
//     `getComponentServerProps` so the SDK can invoke it on the server.
//   - The `Default` render is a thin pass-through that delegates to the
//     `BreadcrumbClient` Client Component, which contains all the hooks and
//     interactive rendering.
export const Default = (props)=>{
    return /*#__PURE__*/ _jsx(BreadcrumbClient, {
        ...props
    });
};
